const rotateResetBtn = () => {
  const resetBtn = document.querySelector('[data-btn-reset]');

  resetBtn?.addEventListener('click', () => {
    const icon = resetBtn.querySelector('svg');
    if (!icon) return;

    icon.animate(
      [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }],
      { duration: 500, easing: 'ease' }
    );
  });
};

export { rotateResetBtn };
